import cn from 'classnames';
import parse from 'html-react-parser';
import { FC } from 'react';
import { match } from 'ts-pattern';

import {
  cleanBuilderParagraphInput,
  cleanBuilderStringInput,
  getBuilderString,
  isBuilderStringPresent,
} from '@/shared/text';

import style from './Header.module.scss';
import { SingleContentType } from './type';

interface Props {
  type: SingleContentType;
  headline?: string;
  description?: string;
  descriptionTextSizeOverride?: string;
  fullWidth?: boolean;
  locale: string;
}

export const Header: FC<Props> = ({
  type,
  headline,
  description,
  descriptionTextSizeOverride,
  fullWidth,
  locale,
}) => {
  if (
    !isBuilderStringPresent(headline, locale) &&
    !isBuilderStringPresent(description, locale)
  ) {
    return null;
  }

  return (
    <div
      data-testid="header"
      className={cn({
        [style.shrink]: fullWidth === false && type === 'standard',
      })}
    >
      {isBuilderStringPresent(headline, locale) ? (
        <span
          data-testid="headline"
          className={cn({
            'u-typography-h1': type === 'standard',
            'u-typography-h2': type === 'number',
          })}
        >
          {parse(cleanBuilderStringInput(getBuilderString(headline, locale)))}
        </span>
      ) : null}
      {isBuilderStringPresent(description, locale) && (
        <div
          data-testid="description"
          className={cn(
            match(type)
              .with('number', () => 'u-typography-h3')
              .otherwise(
                () => descriptionTextSizeOverride || 'u-typography-h3'
              ),
            { 'u-m-t-xl': isBuilderStringPresent(headline, locale) }
          )}
        >
          {parse(
            cleanBuilderParagraphInput(getBuilderString(description, locale))
          )}
        </div>
      )}
    </div>
  );
};
